import { useEffect, useState } from "react";
import {
  DrawerForm,
  ProFormText,
  ProFormSelect,
  ProFormDatePicker,
} from "@ant-design/pro-form";
import message from "antd/es/message";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from 'react-draft-wysiwyg';

import { RequestType, FormProps } from "./types";
import { Endpoints, ISubmitionResponse } from "components/api";
import { dateTimeFormats } from "assets";
import Error from "components/ui/error";
import DependentSelect from "components/ui/fields/dependent-select";
import { convertToRaw, convertFromRaw, EditorState, ContentState } from 'draft-js';
import React from "react";

const Form = (props: FormProps) => {
  const { state, title, visible, onVisibleChange, initialState, onFinish } =
    props;
  const [formErrors, setFormErrors] = useState<ISubmitionResponse>({
    error: null,
    isError: false,
    isSuccess: false,
  });

  const [descriptionState, setDescriptionState] = useState<EditorState>();
  const editorRef = React.useRef<Editor>(null);

  useEffect(() => {
    if (state === 'Edit' && initialState.description) {
      try {
        // Try to parse the description as JSON
        const contentState = convertFromRaw(JSON.parse(initialState.description));
        setDescriptionState(EditorState.createWithContent(contentState));
      } catch (error) {
        // If it's not valid JSON, treat it as normal text
        const contentState = ContentState.createFromText(initialState.description);
        setDescriptionState(EditorState.createWithContent(contentState));
      }
    }
  }, [state, initialState.description]);


  const onEditorStateChange = (editorState: EditorState) => {
    setDescriptionState(editorState);
    //console.log('editorState', editorState.getCurrentContent().getLastBlock());
  }

  const resetErrors = () => {
    if (formErrors.isError) {
      setFormErrors({
        error: null,
        isError: false,
        isSuccess: true,
      });
    }
  };

  return (
    <DrawerForm<RequestType>
      title={`${state} ${title}`}
      size={"middle"}
      style={{ top: 100 }}
      width={"50%"}
      visible={visible}
      onVisibleChange={onVisibleChange}
      autoFocusFirstInput
      request={async () => initialState}
      name="galawo-model-form"
      drawerProps={{
        onClose: () => onVisibleChange(false),
        destroyOnClose: true,
        closable: false,
        maskClosable: false,
      }}
      onFinish={async (values) => {
        console.log(values);
        var result = await onFinish({
          ...values,
          description: JSON.stringify(convertToRaw(descriptionState!.getCurrentContent())),
        });
        if (result.isSuccess) {
          message.success("Successfuly completed");
        }
        setFormErrors(result);
        return result.isSuccess;
      }}
      onChange={resetErrors}
      submitter={{
        searchConfig: {
          resetText: "Cancel",
          submitText: "Submit",
        },
      }}
    >

      <ProFormText
        name="title"
        label="Title"
        placeholder="Enter Title"
        rules={[{ required: true, min: 2, max: 50 }]}
        width="xl"
      />

      <ProFormSelect
        name="companyId"
        label="Company"
        rules={[{ required: true }]}
        width="xl"
        request={async () => props.lookups.data["companies"] ?? []}
        debounceTime={0}
        showSearch={true}
        placeholder="Please select Company"
      />
      <ProFormSelect
        name="departmentId"
        label="Department"
        rules={[{ required: true }]}
        width="xl"
        request={async () => props.lookups.data["departments"] ?? []}
        debounceTime={0}
        showSearch={true}
        placeholder="Please select Department"
      />

      <DependentSelect
        name="employeeId"
        label="Responsible Manager"
        rules={[{ required: true, }]}
        width="xl"
        request={async () => props.lookups.data["employees"] ?? []}
        debounceTime={0}
        showSearch={true}
        placeholder="Please select Employee"
        lookupId="employees"
        dependentTo="companyId"
        dependentLookupProps={{
          endpoint: Endpoints.Employee.lookup + "?companyId",
          fromLookup: false,
          isLocalEnum: false,
          id: "employees",
        }}
      />


      <ProFormText
        name="deliverables"
        label="Deliverables"
        placeholder="Enter Deliverables"
        rules={[{ required: true, min: 2, max: 50 }]}
        width="xl"
      />

      <ProFormSelect
        name="priority"
        label="Priority"
        rules={[{ required: true }]}
        width="xl"
        request={async () => props.lookups.data["priority"] ?? []}
        debounceTime={0}
        showSearch={true}
        placeholder="Please select Priority"
      />
      <ProFormDatePicker
        name="date"
        label="Date"
        rules={[{ required: true, type: "date" }]}
        width="xl"
        fieldProps={{
          format: dateTimeFormats.dateOnly,
        }}
      />
      <ProFormDatePicker

        name="targetCompletedDate"
        label="Target Completion Date"
        rules={[{ required: true, type: "date" }]}
        width="xl"
        fieldProps={{
          format: dateTimeFormats.dateOnly,
        }}

      />


      {/* <ProFormText
        name="description"
        label="Description"
        placeholder="Enter Description"
        rules={[{ required: true, min: 2, max: 50 }]}
        width="xl"
      /> */}
      <Editor
        editorState={descriptionState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={onEditorStateChange}
        editorRef={(ref: object) => { }}
        editorStyle={{ height: "100px" }}


      />
      <Error error={formErrors.error} isError={formErrors.isError} />
    </DrawerForm>
  );
};

export default Form;
